import {combineReducers } from 'redux';

// I would love to eventually write a shell process that generates this file dynamically from directory
// structure, as currently the only manual task in prepping this file for a new module is the import and
// inclusion of sub-reducers.
import user from './user';
import input_nodes from './input-nodes';

const subtree = {
    user,
    input_nodes
};

const state = Object.keys(subtree).reduce((agg, v) => {agg[v] = subtree[v].defaultState; return agg;}, {});
const reducer = combineReducers(Object.keys(subtree).reduce((agg, v) => {agg[v] = subtree[v].reducer; return agg;}, {}));

export default {
    state,
    reducer
};